	import * as maptalks from 'maptalks'

	function TalksMap(mapid) {
		this.mapDom = ''
		this.dialogMapDom=''
		//		卫星图层
		//2635b736fcd04978596f1e7b0a2ad8d6
		this.url = "http://t0.tianditu.gov.cn/img_w/wmts?" +
			"SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=img&STYLE=default&TILEMATRIXSET=w&FORMAT=tiles" +
			"&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}" +
			"&tk=154ec0f1c3e31efd7806545e0aa9a047"
		this.wordUrl = "http://t0.tianditu.gov.cn/cia_w/wmts?" +
			"SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=cia&STYLE=default&TILEMATRIXSET=w&FORMAT=tiles" +
			"&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}" +
			"&tk=154ec0f1c3e31efd7806545e0aa9a047"
	}
	TalksMap.prototype.init = function(container) {
		this.mapDom = new maptalks.Map(container, {
			center: [121.48848100292, 31.2097925548583],
			crossOrigin: 'Anonymous',
			zoom: 9,
			maxZoom :18,
			baseLayer: new maptalks.TileLayer('base', {
				urlTemplate: this.url,
				subdomains: ['1', '2', '3', '4'],
				attribution: '&copy; <a href="http://osm.org">OpenStreetMap</a> contributors, &copy; <a href="https://carto.com/">CARTO</a>'
			}),
			layers: [
				new maptalks.TileLayer('boudaries', {
					'urlTemplate': this.wordUrl,
					'subdomains': ['1', '2', '3', '4']
				})
			]
		})
	}
TalksMap.prototype.initDialog = function(container) {
		this.dialogMapDom = new maptalks.Map(container, {
			center: [121.48848100292, 31.2097925548583],
			crossOrigin: 'Anonymous',
			zoom: 9,
			maxZoom :18,
			baseLayer: new maptalks.TileLayer('base', {
				urlTemplate: this.url,
				subdomains: ['1', '2', '3', '4'],
				attribution: '&copy; <a href="http://osm.org">OpenStreetMap</a> contributors, &copy; <a href="https://carto.com/">CARTO</a>'
			}),
			layers: [
				new maptalks.TileLayer('boudaries', {
					'urlTemplate': this.wordUrl,
					'subdomains': ['1', '2', '3', '4']
				})
			]
		})
	}
	export default TalksMap


// WEBPACK FOOTER //
// ./src/map/js/initMapTalks旧.js